import { handlePortMessage, loadPlayer } from './player.ts';
import { portConnected } from './playerEvents.ts';
import { L } from './utils.ts';

if (amusic.port) {
  L.info(`MessagePort is ready`);
  amusic.port.onmessage = handlePortMessage;

  // The port object has already been obtained, so it can be used immediately.
  // There is no need to delay with setTimeout. If removing the delay does not
  // cause any functional issues, please remove the setTimeout for optimization.
  setTimeout(() => {
    portConnected();
  }, 30);
} else {
  globalThis.addEventListener('port-ready', () => {
    L.info(`MessagePort is ready`);
    amusic.port!.onmessage = handlePortMessage;

    // The port object has already been obtained, so it can be used immediately.
    // There is no need to delay with setTimeout. If removing the delay does not
    // cause any functional issues, please remove the setTimeout for optimization.
    setTimeout(() => {
      portConnected();
    }, 30);
  });
}

if (amusic.isMusicKitLoaded) {
  loadPlayer();
} else {
  document.addEventListener('musickitloaded', () => {
    L.info(`MusicKit loaded`);
    amusic.isMusicKitLoaded = true;
    loadPlayer();
  });
}
